import tokenImage from "assets/images/details/tokenImage.svg";
import xTokenImage from "assets/images/details/xtokenImage.svg";
import lockImage from "assets/images/details/lock.svg";
import coinTowerImage from "assets/images/details/coinTower.svg";
import walletImage from "assets/images/details/wallet.svg";
import webImage from "assets/images/details/web.svg";
import angelsIcon from "assets/images/details/partners/subtext/angels.svg";
import angelsMobileIcon from "assets/images/details/partners/subtext/angels-mobile.svg";
import blockChainIcon from "assets/images/details/partners/subtext/blockchain.svg";
import blockChainMobileIcon from "assets/images/details/partners/subtext/blockchain-mobile.svg";
import fundsIcon from "assets/images/details/partners/subtext/funds.svg";
import fundsMobileIcon from "assets/images/details/partners/subtext/funds-mobile.svg";

// Defi Images
import aaveImage from "assets/images/details/aave.svg";
import balancerImage from "assets/images/details/balancer.svg";
import quickswapImage from "assets/images/details/quickswap.svg";
import beefyImage from "assets/images/details/beefy.svg";
import meshswapImage from "assets/images/details/meshswap.svg";
import deltaImage from "assets/images/details/delta.svg";
import qidaoImage from "assets/images/details/qidao.svg";
import cianImage from "assets/images/details/cian.png";

// Auditors & Bug Bounty Platform Images
import halbornImage from "assets/images/details/halborn.svg";
import immuneBytesImage from "assets/images/details/immuneBytes.svg";
import immunefiImage from "assets/images/details/immunefi.svg";

// Funds
import fund1Image from "assets/images/details/partners/funds/fund_1.svg";
import fund2Image from "assets/images/details/partners/funds/fund_2.svg";
// import fund3Image from "assets/images/details/partners/funds/fund_3.svg"; // Three Arrow Capital
import fund4Image from "assets/images/details/partners/funds/fund_4.svg";
import fund5Image from "assets/images/details/partners/funds/fund_5.svg";
import fund6Image from "assets/images/details/partners/funds/fund_6.svg";
import fund7Image from "assets/images/details/partners/funds/fund_7.svg";
import fund8Image from "assets/images/details/partners/funds/fund_8.svg";
import fund9Image from "assets/images/details/partners/funds/fund_9.svg";
import fund10Image from "assets/images/details/partners/funds/fund_10.svg";
import fund11Image from "assets/images/details/partners/funds/fund_11.svg";
import fund12Image from "assets/images/details/partners/funds/fund_12.svg";
import fund13Image from "assets/images/details/partners/funds/fund_13.svg";
import fund14Image from "assets/images/details/partners/funds/fund_14.svg";
import fund15Image from "assets/images/details/partners/funds/fund_15.svg";
import fund16Image from "assets/images/details/partners/funds/fund_16.svg";
import fund17Image from "assets/images/details/partners/funds/fund_17.svg";
import fund18Image from "assets/images/details/partners/funds/fund_18.svg";

// Partners
import partner1Image from "assets/images/details/partners/partners/partner_1.svg";
import partner2Image from "assets/images/details/partners/partners/partner_2.svg";
import partner3Image from "assets/images/details/partners/partners/partner_3.svg";
import partner4Image from "assets/images/details/partners/partners/partner_4.svg";
import partner5Image from "assets/images/details/partners/partners/partner_5.svg";
import partner6Image from "assets/images/details/partners/partners/partner_6.svg";
import partner7Image from "assets/images/details/partners/partners/partner_7.svg";
import partner8Image from "assets/images/details/partners/partners/partner_8.svg";
import partner9Image from "assets/images/details/partners/partners/partner_9.svg";
import partner10Image from "assets/images/details/partners/partners/partner_10.svg";

// FundedBlockchains
import nearImage from "assets/images/details/partners/fundedChains/near.svg";
import solanaImage from "assets/images/details/partners/fundedChains/solana.svg";
import fantomImage from "assets/images/details/partners/fundedChains/fantom.svg";
import hederaImage from "assets/images/details/partners/fundedChains/hedera.svg";
// import bnbImage from "assets/images/details/partners/fundedChains/bnb.svg";

// Constant
import {
  HALBORN_AUDIT_LINK,
  IMMUNEBYTES_AUDIT_LINK,
  IMMUNEFI_LINK,
} from "./contracts";

export const MEET = "meet";
export const WORK = "work";
export const DEFI = "defi";
export const SAFE = "safe";
export const PARTNERS = "partners";
export const COMMUNITY = "community";
export const SUBSCRIBE = "subscribe";

interface ObjectLiteral {
  [key: string]: any;
}

export const navItemEventMapping: ObjectLiteral = {
  [WORK]: "view_how_it_works",
  [DEFI]: "view_ecosystem",
  [SAFE]: "view_safe_secure",
  [PARTNERS]: "view_partners",
  [COMMUNITY]: "view_communities",
  [SUBSCRIBE]: "view_newsletter",
};

export const navItems = [
  {
    id: WORK,
    label: "How MaticX works",
  },
  {
    id: DEFI,
    label: "MaticX DeFi ecosystem",
  },
  {
    id: SAFE,
    label: "Security",
  },
  {
    id: PARTNERS,
    label: "Our partners",
  },
  {
    id: COMMUNITY,
    label: "Community",
  },
];

export const maticxHighlights = [
  {
    icon: tokenImage,
    title: "Simple",
    description:
      "Stake your Matic the simplest way possible. No minimums. No lockups. One-click staking",
  },
  {
    icon: xTokenImage,
    title: "DeFi Ready",
    description:
      "Use your MaticX for liquidity mining, lending, trading staked positions and more",
  },
  {
    icon: lockImage,
    title: "Secure",
    description:
      "Best-in-class security - audited by Halborn & Immunebytes, a $1M bug bounty on Immunefi and live monitoring with Forta",
  },
];

export const howItWorks = [
  {
    icon: coinTowerImage,
    title: "Stake Matic",
    description:
      "Stake your Matic for daily staking rewards. Use Polygon or ETH chain to stake with Best-in-class validators",
  },
  {
    icon: walletImage,
    title: "Receive MaticX",
    description:
      "Get MaticX for your staked Matic. MaticX accrues, autocompounds rewards and grows in value.",
  },
  {
    icon: webImage,
    title: "Participate in DeFi",
    description:
      "Use your MaticX to access DeFi while earning staking rewards. Get the best of both worlds.",
  },
];

export const defiEcosystem = [
  {
    icon: aaveImage,
    title: "AAVE",
  },
  {
    icon: balancerImage,
    title: "Balancer",
  },
  {
    icon: cianImage,
    title: "CIAN",
  },
  {
    icon: beefyImage,
    title: "Beefy Finance",
  },
  {
    icon: meshswapImage,
    title: "Meshswap",
  },
  {
    icon: deltaImage,
    title: "Delta Theta",
  },
  {
    icon: qidaoImage,
    title: "QiDAO",
  },
  {
    icon: quickswapImage,
    title: "Quickswap",
  },
];

export const auditInfo = [
  {
    icon: halbornImage,
    title: "Halborn",
    link: HALBORN_AUDIT_LINK,
  },
  {
    icon: immuneBytesImage,
    title: "Immune Bytes",
    link: IMMUNEBYTES_AUDIT_LINK,
  },
];

export const bugBountyInfo = [
  {
    icon: immunefiImage,
    title: "Immunefi",
    description: "Report a bug and earn bounty (upto $1M)",
    link: IMMUNEFI_LINK,
  },
];

export const blockchainFunds = [
  nearImage,
  solanaImage,
  fantomImage,
  hederaImage,
  // bnbImage,
];

export const angels = [
  {
    name: "Sandeep Nailwal",
    designation: "Co-Founder & COO at Polygon",
  },
  {
    name: "Jaynti Kanani",
    designation: "Co-founder & CEO at Polygon",
  },
  {
    name: "Diogo Monica",
    designation: "Co-founder at Anchorage",
  },
  {
    name: "Tim Ogilvie",
    designation: "Co-founder & CEO at Staked",
  },
  {
    name: "Nemil Dalal",
    designation: "Head of Crypto at Coinbase",
  },
  {
    name: "Chris McCann",
    designation: "Investor at Race Capital",
  },
  {
    name: "Ahmed Al-Balaghi",
    designation: "Co-founder at Biconomy",
  },
  {
    name: "Aniket Jindal",
    designation: "Co-founder at Biconomy",
  },
  {
    name: "Akash Garg",
    designation: "CTO at Afterpay",
  },
  {
    name: "Harsh Rajat",
    designation: "Co-founder & CEO at EPNS",
  },
  {
    name: "Sumit Gupta",
    designation: "Co-founder & CEO at CoinDCX",
  },
];

export const partnerInfo = {
  funds: {
    icon: fundsIcon,
    iconMobile: fundsMobileIcon,
    text: "15+ Funds",
  },
  blockChains: {
    icon: blockChainIcon,
    iconMobile: blockChainMobileIcon,
    text: `${blockchainFunds.length} Blockchains`,
  },
  angels: {
    icon: angelsIcon,
    iconMobile: angelsMobileIcon,
    text: `${angels.length} Angels`,
  },
  partners: [
    partner1Image,
    partner2Image,
    partner3Image,
    partner4Image,
    partner5Image,
    partner6Image,
    partner7Image,
    partner8Image,
    partner9Image,
    partner10Image,
  ],
};

export const funds = [
  fund1Image,
  fund2Image,
  // fund3Image, // Three Arrow Capital
  fund4Image,
  fund5Image,
  fund6Image,
  fund7Image,
  fund8Image,
  fund9Image,
  fund10Image,
  fund11Image,
  fund12Image,
  fund13Image,
  fund14Image,
  fund15Image,
  fund16Image,
  fund17Image,
  fund18Image,
];

export const drawerNavItems = [
  {
    id: "funds",
    label: "Funds",
  },
  {
    id: "blockchains",
    label: "Blockchains",
  },
  {
    id: "angels",
    label: "Angels",
  },
];
